import useGetCountry from './useGetCountry';
import CountryEnum from '../constants/country-enum';

const isMexicoEnabled = process.env.REACT_APP_ENABLE_MEXICO !== 'false';

const useIsMexicoDisabled = () => {
  const country = useGetCountry();
  return country === CountryEnum.MEXICO && !isMexicoEnabled;
};

export { isMexicoEnabled, useIsMexicoDisabled };
